import * as BoneWeb from "@bone/web";

export {
    BoneWeb
}

export default {
    "@bone/web": BoneWeb
}


// WEBPACK FOOTER //
// ./packages/bone-web@0.2/index.js